import { CreateGameSheet } from '@/components/CreateGameSheet/CreateGameSheet'

export default function () {
  return <CreateGameSheet />
}
